/**
 * @param {array} alerts
 * @returns {object}
 */
const getAlertsFilter = (alerts) => {
  if (!alerts) return {};

  return (alerts || []).reduce((acc, current) => {
    if (current.value === 'problematic') {
      return { ...acc, [current.value]: true };
    }

    return { ...acc, has_alerts: [...(acc.has_alerts || []), current.value] };
  }, {});
};

export default getAlertsFilter;
